/**
 * Best betting platforms — `/betting-gaming/best-betting-platforms`
 */
import { BEST_BETTING_PLATFORMS_SLUG, bestBettingPlatformsDefaultData } from "./bestBettingPlatformsData";
import {
  BestBettingPlatformsArticlesTab,
  BestBettingPlatformsMediaTab,
  BestBettingPlatformsOverviewTab,
} from "./BestBettingPlatformsDesign";

export const bestBettingPlatformsModule = {
  slug: BEST_BETTING_PLATFORMS_SLUG,
  getDefaultData: () => bestBettingPlatformsDefaultData,
  Views: {
    overview: BestBettingPlatformsOverviewTab,
    articles: BestBettingPlatformsArticlesTab,
    media: BestBettingPlatformsMediaTab,
  },
};
